import { render, staticRenderFns } from "./CatalogRulesets.vue?vue&type=template&id=30386e68"
import script from "./CatalogRulesets.vue?vue&type=script&lang=js"
export * from "./CatalogRulesets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports